// Translation for pt
export const pt = {
        common: {
            save: 'Salvar',
            cancel: 'Cancelar',
            close: 'Fechar',
            delete: 'Deletar',
            edit: 'Editar',
            activate: 'Ativar',
            add: 'Adicionar',
            saving: 'Salvando...',
            loading: 'Carregando...',
            active: 'ATIVO',
            inUse: 'Em Uso',
            test: 'Teste',
            searchApps: 'Pesquisar apps...',
            betaBanner: 'BETA - Serviço não disponível ainda!'
        },
        header: {
            creditBalance: 'Saldo',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Entrar',
            signUp: 'Cadastrar',
            username: 'Nome de usuário',
            password: 'Senha',
            continue: 'Continuar',
            noAccount: 'Não tem uma conta?',
            hasAccount: 'Já tem uma conta?',
            loginError: 'Falha no login',
            invalidCredentials: 'Nome de usuário ou senha inválidos',
            rateLimited: 'Muitas tentativas de login. Aguarde um momento.',
            sessionExpired: 'Sua sessão expirou. Use um novo link mágico.',
            magicLinkInvalid: 'O link de login é inválido ou expirou.',
            magicLinkSuccess: 'Bem-vindo! Você foi logado com sucesso.',
            magicLinkProcessing: 'Processando login...',
            connectionError: 'Erro de conexão. Tente novamente.'
        },
        profile: {
            myProgress: 'Meu Progresso de Aprendizado',
            signOut: 'Sair',
            plan: 'Plano: '
        },
        settings: {
            title: 'Configurações',
            tabs: {
                uiSettings: 'Configurações de UI',
                systemPrompt: 'Prompt do Sistema',
                llmProfiles: 'Perfis LLM',
                ttsProfiles: 'Perfis TTS',
                language: 'Idioma',
            },
            uiSettings: {
                title: 'Interface do Usuário',
                themeMode: 'Modo de Tema',
                darkMode: 'Modo Escuro',
                lightMode: 'Modo Claro',
                themeColor: 'Cor do Tema',
                themeColorDesc: 'Escolha a cor de destaque para botões, ícones e realces',
                background: 'Fundo',
                backgroundDesc: 'Escolha um fundo para seu espaço de trabalho',
                selectBackgroundColor: 'Selecionar Cor de Fundo',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Foco',
                    concentration: 'Concentração',
                    relaxation: 'Relaxamento',
                    lianas: 'Lianas',
                    color: 'Cor'
                },
                backgroundColors: {
                    deepDark: 'Preto Profundo',
                    darkGrey: 'Cinza Escuro',
                    midnightBlue: 'Azul Meia-Noite',
                    indigo: 'Índigo',
                    darkTeal: 'Verde-Azulado Escuro',
                    brown: 'Marrom',
                    darkRed: 'Vermelho Escuro',
                    deepPurple: 'Roxo Profundo',
                    pureWhite: 'Branco Puro',
                    softWhite: 'Branco Suave',
                    lightGrey: 'Cinza Claro',
                    paleBlue: 'Azul Pálido',
                    paleGreen: 'Verde Pálido',
                    paleOrange: 'Laranja Pálido',
                    lavender: 'Lavanda',
                    blueGrey: 'Azul-Cinzento'
                }
            },
            systemPrompt: {
                label: 'Prompt do Sistema:',
                placeholder: 'Carregando prompt do sistema...',
                emptyError: 'O prompt do sistema não pode estar vazio!',
                saveSuccess: '✓ Prompt do sistema salvo com sucesso!',
                loadError: 'Erro ao carregar o prompt do sistema',
                saveError: 'Erro ao salvar'
            },
            llmProfiles: {
                addButton: '+ Adicionar Nova Conexão',
                newConnection: 'Nova Conexão',
                editConnection: 'Editar Conexão',
                emptyState: 'Nenhuma conexão LLM disponível. Clique abaixo para adicionar uma.',
                loadingProfiles: 'Carregando perfis...',
                nameLabel: 'Nome *',
                namePlaceholder: 'p.ex. OpenAI GPT-4',
                apiUrlLabel: 'URL da API *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'Chave da API *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Modelo *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: 'Todos os campos devem ser preenchidos!',
                saveSuccess: '✓ Perfil salvo com sucesso!',
                deleteConfirm: 'Você realmente quer deletar "{name}"?',
                profileNotFound: 'Perfil não encontrado!',
                loadError: 'Erro ao carregar perfis',
                saveError: 'Erro ao salvar',
                activateError: 'Erro ao ativar',
                deleteError: 'Erro ao deletar',
                modelInfo: 'Modelo: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Adicionar Nova Voz',
                newVoice: 'Nova Voz',
                editVoice: 'Editar Voz',
                emptyState: 'Nenhum perfil TTS disponível. Clique abaixo para adicionar um.',
                loadingProfiles: 'Carregando perfis TTS...',
                nameLabel: 'Nome',
                namePlaceholder: 'p.ex. Meu ElevenLabs Adam',
                providerLabel: 'Provedor',
                providerPlaceholder: 'p.ex. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'URL da API *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'Chave da API *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'ID do Modelo *',
                modelIdPlaceholder: 'p.ex. eleven_monolingual_v1',
                voiceIdLabel: 'ID da Voz',
                voiceIdPlaceholder: 'p.ex. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Todos os campos devem ser preenchidos!',
                saveSuccess: '✓ Perfil TTS salvo com sucesso!',
                deleteConfirm: 'Você realmente quer deletar "{name}"?',
                loadError: 'Erro ao carregar perfis TTS',
                saveError: 'Erro ao salvar',
                activateError: 'Erro ao ativar',
                deleteError: 'Erro ao deletar'
            },
            language: {
                title: 'Escolher Idioma',
                description: 'Selecione seu idioma preferido para a interface do usuário'
            },
        },
        chat: {
            ready: 'Pronto',
            start: 'INICIAR',
            stop: 'PARAR',
            initialMessage: 'Clique em INICIAR para conversa em tempo real.',
            listening: 'Ouvindo...',
            speaking: 'Thorsten está falando...',
            userLabel: 'Você',
            aiLabel: 'IA',
            modalTitle: 'Chat IA Thorsten',
            inputPlaceholder: 'Digite uma mensagem...',
            send: 'Enviar',
            loginRequired: 'Faça login para usar este serviço.',
            loginButton: 'Entrar Agora',
            magicLinkRequired: 'Use um link mágico para entrar.',
            creditLimitError: 'Sua cota horária foi esgotada. Atualize seu plano (Medium/Premium) para continuar.',
            serviceDisabled: 'O serviço de chat está indisponível no momento. Tente novamente mais tarde.'
        },
        notifications: {
            error: 'Erro',
            success: 'Sucesso',
            info: 'Informação',
            unknownError: 'Um erro desconhecido ocorreu'
        },
        cookie: {
            message: 'Este site usa cookies para fornecer a melhor experiência possível.',
            accept: 'Aceitar'
        },
        curriculum: {
                buttonLabel: 'Currículo',
                buttonTitle: 'Mostrar conteúdo do currículo',
                modalTitle: 'Currículo do {app}',
                sections: {
                    topic: 'Tópico do currículo',
                    explanation: 'Explicação para crianças',
                    studentProfile: 'Perfil do aluno'
                },
                topic: {
                    empty: 'Nenhum tópico do currículo está vinculado a este microaplicativo no backend.',
                    missingDetail: 'Dados detalhados do currículo para este microaplicativo ainda não estão disponíveis no backend.',
                    learningGoals: 'Objetivos de aprendizagem',
                    prerequisites: 'Pré-requisitos',
                    unitLabel: 'Unidade',
                    durationLabel: 'Duração',
                    difficultyLabel: 'Dificuldade',
                    hours: 'h',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Nenhuma explicação para crianças disponível.',
                    loadingPrepare: 'A IA está preparando a explicação',
                    loadingExplain: 'A IA está explicando o tópico em linguagem para crianças',
                    requestFailed: 'Não foi possível gerar a explicação para crianças.'
                },
                studentProfile: {
                    country: 'País',
                    region: 'Estado / Região',
                    schoolType: 'Tipo de escola',
                    grade: 'Série',
                    noContext: 'Nenhum contexto do aluno disponível.',
                    childProfileNotFound: 'Nenhum perfil de aluno foi encontrado no backend para o login atual.',
                    loginProfileIncomplete: 'O perfil de login ainda não contém um contexto completo do aluno.',
                    educationContextNotFound: 'Um perfil de aluno foi encontrado, mas nenhuma atribuição de currículo está definida.',
                    noToken: 'Nenhum aluno conectado encontrado.'
                },
                errors: {
                    signInRequired: 'Faça login para visualizar o currículo.',
                    appIdMissing: 'ID do aplicativo está faltando.',
                    loadFailed: 'Não foi possível carregar os dados do currículo.'
                }
            }
    };
